const EVENTS = {
  RATING_ADDED: "my_tour_rating_added",
  LISTING_SAVED: "listing_saved",
  LISTING_REMOVED: "listing_removed",
  PROGRESS_CHANGED: "listing_progress_changed"
};

export default EVENTS;
